<template>
  <!-- receipting modal -->
  <div class="modal fade receipting-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
       aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-primary text-white">
          <h5 class="modal-title text-white" id="myLargeModalLabel">
            <i class="bx bx-store-alt me-2"></i>Business Details - {{ businessDetails.businessName || 'Loading...' }}
          </h5>
          <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <!-- Progress Timeline -->
            <div class="col-12 mb-4">
              <div class="progress-wrapper">
                <div class="row text-center">
                  <div class="col-4">
                    <div class="step-indicator" :class="{'completed': billDetails.status === 'PAID' || billDetails.status === 'INVOICED'}">
                      <div class="step-icon bg-success text-white">
                        <i class="bx bx-receipt"></i>
                      </div>
                      <p class="mb-0 mt-2">Invoiced</p>
                      <small class="text-muted">{{ formatDate(billDetails.dateCreated) }}</small>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="step-indicator" :class="{'completed': billDetails.status === 'PAID'}">
                      <div class="step-icon" :class="billDetails.status === 'PAID' ? 'bg-success text-white' : 'bg-secondary text-white'">
                        <i class="bx bx-money"></i>
                      </div>
                      <p class="mb-0 mt-2">Payment</p>
                      <small class="text-muted">{{ billDetails.status === 'PAID' ? 'Completed' : 'Pending' }}</small>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="step-indicator">
                      <div class="step-icon bg-secondary text-white">
                        <i class="bx bx-check-circle"></i>
                      </div>
                      <p class="mb-0 mt-2">Permit Issued</p>
                      <small class="text-muted">{{ businessDetails.renewalStatus === 'APPROVED' ? 'Approved' : 'Pending' }}</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Business Information Section -->
            <div class="col-md-6 mb-4">
              <div class="card border-0 shadow-sm h-100">
                <div class="card-header bg-light">
                  <h6 class="mb-0"><i class="bx bx-building me-2"></i>Business Information</h6>
                </div>
                <div class="card-body">
                  <div class="row g-3">
                    <div class="col-6">
                      <label class="text-muted small">Business ID</label>
                      <div class="input-group">
                        <input type="text" class="form-control fw-bold" :value="businessDetails.businessID" readonly>
                        <button class="btn btn-outline-secondary" type="button" @click="copyToClipboard(businessDetails.businessID)">
                          <i class="bx bx-copy"></i>
                        </button>
                      </div>
                    </div>
                    <div class="col-6">
                      <label class="text-muted small">Business Name</label>
                      <input type="text" class="form-control fw-bold" :value="businessDetails.businessName" readonly>
                    </div>
                    <div class="col-6">
                      <label class="text-muted small">Category</label>
                      <input type="text" class="form-control" :value="businessDetails.businessCategory" readonly>
                    </div>
                    <div class="col-6">
                      <label class="text-muted small">Sub Category</label>
                      <input type="text" class="form-control text-wrap" style="height: auto;" :value="businessDetails.businessSubCategory" readonly>
                    </div>
                    <div class="col-12">
                      <label class="text-muted small">Business Description</label>
                      <textarea class="form-control" rows="2" :value="businessDetails.businessDes" readonly></textarea>
                    </div>
                    <div class="col-6">
                      <label class="text-muted small">Employees</label>
                      <input type="text" class="form-control" :value="businessDetails.numberOfEmployees" readonly>
                    </div>
                    <div class="col-6">
                      <label class="text-muted small">Premise Size</label>
                      <input type="text" class="form-control" :value="businessDetails.premiseSize + ' sqm'" readonly>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Location & Contact Section -->
            <div class="col-md-6 mb-4">
              <div class="card border-0 shadow-sm h-100">
                <div class="card-header bg-light">
                  <h6 class="mb-0"><i class="bx bx-map me-2"></i>Location & Contact</h6>
                </div>
                <div class="card-body">
                  <div class="row g-3">
                    <div class="col-6">
                      <label class="text-muted small">Sub County</label>
                      <input type="text" class="form-control" :value="businessDetails.subCountyName" readonly>
                    </div>
                    <div class="col-6">
                      <label class="text-muted small">Ward</label>
                      <input type="text" class="form-control" :value="businessDetails.wardName" readonly>
                    </div>
                    <div class="col-12">
                      <label class="text-muted small">Physical Address</label>
                      <input type="text" class="form-control" :value="businessDetails.physicalAddress" readonly>
                    </div>
                    <div class="col-6">
                      <label class="text-muted small">Building Name</label>
                      <input type="text" class="form-control" :value="businessDetails.buildingName" readonly>
                    </div>
                    <div class="col-6">
                      <label class="text-muted small">Plot Number</label>
                      <input type="text" class="form-control" :value="businessDetails.plotNumber" readonly>
                    </div>
                    <div class="col-4">
                      <label class="text-muted small">Floor</label>
                      <input type="text" class="form-control" :value="businessDetails.floorNo" readonly>
                    </div>
                    <div class="col-4">
                      <label class="text-muted small">Room No.</label>
                      <input type="text" class="form-control" :value="businessDetails.roomNo" readonly>
                    </div>
                    <div class="col-4">
                      <label class="text-muted small">Postal Code</label>
                      <input type="text" class="form-control" :value="businessDetails.postalCode" readonly>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Owner Information Section -->
            <div class="col-md-6 mb-4">
              <div class="card border-0 shadow-sm">
                <div class="card-header bg-light">
                  <h6 class="mb-0"><i class="bx bx-user me-2"></i>Owner Information</h6>
                </div>
                <div class="card-body">
                  <div class="row g-3">
                    <div class="col-12">
                      <label class="text-muted small">Full Names</label>
                      <input type="text" class="form-control fw-bold" :value="businessDetails.fullNames || businessDetails.owner" readonly>
                    </div>
                    <div class="col-6">
                      <label class="text-muted small">ID Number</label>
                      <input type="text" class="form-control" :value="businessDetails.ownerID" readonly>
                    </div>
                    <div class="col-6">
                      <label class="text-muted small">KRA PIN</label>
                      <input type="text" class="form-control" :value="businessDetails.kraPin" readonly>
                    </div>
                    <div class="col-6">
                      <label class="text-muted small">Phone Number</label>
                      <div class="input-group">
                        <input type="text" class="form-control" :value="businessDetails.ownerPhone" readonly>
                        <a :href="'tel:' + businessDetails.ownerPhone" class="btn btn-outline-primary">
                          <i class="bx bx-phone"></i>
                        </a>
                      </div>
                    </div>
                    <div class="col-6">
                      <label class="text-muted small">Email</label>
                      <input type="text" class="form-control" :value="businessDetails.ownerEmail" readonly>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Invoice & Payment Section -->
            <div class="col-md-6 mb-4">
              <div class="card border-0 shadow-sm">
                <div class="card-header" :class="billDetails.status === 'PAID' ? 'bg-success text-white' : 'bg-warning'">
                  <h6 class="mb-0" :class="billDetails.status === 'PAID' ? 'text-white' : ''">
                    <i class="bx bx-receipt me-2"></i>Invoice Details
                    <span class="badge float-end" :class="billDetails.status === 'PAID' ? 'bg-white text-success' : 'bg-danger text-white'">
                      {{ billDetails.status }}
                    </span>
                  </h6>
                </div>
                <div class="card-body">
                  <div class="row g-3">
                    <div class="col-12">
                      <label class="text-muted small">Bill Number</label>
                      <div class="input-group">
                        <input type="text" class="form-control fw-bold" :value="billDetails.billNo" readonly>
                        <button class="btn btn-outline-secondary" type="button" @click="copyToClipboard(billDetails.billNo)">
                          <i class="bx bx-copy"></i>
                        </button>
                      </div>
                    </div>
                    <div class="col-12">
                      <label class="text-muted small">Fee Description</label>
                      <textarea class="form-control" rows="2" :value="billDetails.feeDescription" readonly></textarea>
                    </div>
                    <div class="col-4">
                      <label class="text-muted small">Amount</label>
                      <input type="text" class="form-control fw-bold" :value="'KES ' + numberFormat(billDetails.detailAmount)" readonly>
                    </div>
                    <div class="col-4">
                      <label class="text-muted small">Paid</label>
                      <input type="text" class="form-control text-success fw-bold" :value="'KES ' + numberFormat(billDetails.receiptAmount)" readonly>
                    </div>
                    <div class="col-4">
                      <label class="text-muted small">Balance</label>
                      <input type="text" class="form-control fw-bold"
                             :class="billDetails.billBalance > 0 ? 'text-danger' : 'text-success'"
                             :value="'KES ' + numberFormat(billDetails.billBalance)" readonly>
                    </div>
                  </div>

                  <!-- Payment Information if Paid -->
                  <div v-if="billDetails.status === 'PAID'" class="mt-3 p-3 bg-light rounded">
                    <h6 class="text-success mb-2"><i class="bx bx-check-circle me-2"></i>Payment Information</h6>
                    <div class="row g-2">
                      <div class="col-6">
                        <small class="text-muted">Transaction Code:</small>
                        <p class="mb-0 fw-bold">{{ billDetails.transactionCode || 'N/A' }}</p>
                      </div>
                      <div class="col-6">
                        <small class="text-muted">Payment Method:</small>
                        <p class="mb-0 fw-bold">{{ billDetails.source || 'N/A' }}</p>
                      </div>
                      <div class="col-6">
                        <small class="text-muted">Paid By:</small>
                        <p class="mb-0">{{ billDetails.paidBy || 'N/A' }}</p>
                      </div>
                      <div class="col-6">
                        <small class="text-muted">Date Paid:</small>
                        <p class="mb-0">{{ formatDate(billDetails.dateCreated) }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Additional Business Info -->
            <div class="col-md-6 mb-4">
              <div class="card border-0 shadow-sm">
                <div class="card-header bg-light">
                  <h6 class="mb-0"><i class="bx bx-info-circle me-2"></i>Additional Information</h6>
                </div>
                <div class="card-body">
                  <div class="row g-3">
                    <div class="col-6">
                      <label class="text-muted small">Contact Person</label>
                      <input type="text" class="form-control" :value="businessDetails.contactPersonNames" readonly>
                    </div>
                    <div class="col-6">
                      <label class="text-muted small">Contact Role</label>
                      <input type="text" class="form-control" :value="businessDetails.businessRole" readonly>
                    </div>
                    <div class="col-6">
                      <label class="text-muted small">Contact Phone</label>
                      <input type="text" class="form-control" :value="businessDetails.contactPersonPhone" readonly>
                    </div>
                    <div class="col-6">
                      <label class="text-muted small">Business Phone</label>
                      <input type="text" class="form-control" :value="businessDetails.businessPhone" readonly>
                    </div>
                    <div class="col-12">
                      <label class="text-muted small">Business Email</label>
                      <input type="text" class="form-control" :value="businessDetails.businessEmail" readonly>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- License Status -->
            <div class="col-md-6 mb-4">
              <div class="card border-0 shadow-sm">
                <div class="card-header bg-light">
                  <h6 class="mb-0"><i class="bx bx-shield-quarter me-2"></i>License Status</h6>
                </div>
                <div class="card-body">
                  <div class="row g-3">
                    <div class="col-6">
                      <label class="text-muted small">Renewal Status</label>
                      <input type="text" class="form-control fw-bold"
                             :class="businessDetails.renewalStatus === 'INVOICED' ? 'text-warning' : 'text-success'"
                             :value="businessDetails.renewalStatus" readonly>
                    </div>
                    <div class="col-6">
                      <label class="text-muted small">Year</label>
                      <input type="text" class="form-control" :value="businessDetails.year || '2025'" readonly>
                    </div>
                    <div class="col-6">
                      <label class="text-muted small">Fire License</label>
                      <input type="text" class="form-control" :value="businessDetails.fireLicence" readonly>
                    </div>
                    <div class="col-6">
                      <label class="text-muted small">Liquor License</label>
                      <input type="text" class="form-control" :value="businessDetails.liquorLicence" readonly>
                    </div>
                    <div class="col-12">
                      <label class="text-muted small">Department</label>
                      <input type="text" class="form-control" :value="billDetails.department || 'Health And Medical Services'" readonly>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Registration Info -->
            <div class="col-12">
              <div class="card border-0 shadow-sm">
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-3">
                      <small class="text-muted">Registered On:</small>
                      <p class="mb-0">{{ formatDate(businessDetails.registeredOn || businessDetails.dateCreated) }}</p>
                    </div>
                    <div class="col-md-3">
                      <small class="text-muted">Registered By:</small>
                      <p class="mb-0">{{ businessDetails.registeredBy || businessDetails.createdBy }}</p>
                    </div>
                    <div class="col-md-3">
                      <small class="text-muted">Invoiced By:</small>
                      <p class="mb-0">{{ billDetails.names || 'N/A' }}</p>
                    </div>
                    <div class="col-md-3">
                      <small class="text-muted">Officer Phone:</small>
                      <p class="mb-0">{{ billDetails.phoneNumber || 'N/A' }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer bg-light">
          <div class="d-flex justify-content-between w-100">
            <div>
              <button v-if="billDetails.billBalance > 0" @click="$emit('show-payment-modal')"
                      type="button" class="btn btn-success me-2">
                <i class="bx bx-credit-card me-2"></i>
                Pay Balance (KES {{ numberFormat(billDetails.billBalance) }})
              </button>
              <button @click="$emit('print-invoice', billDetails.billNo)" type="button" class="btn btn-primary me-2">
                <i class="bx bx-printer me-2"></i>Print Invoice
              </button>
              <button v-if="billDetails.status === 'PAID'" @click="$emit('print-receipt', billDetails)" type="button" class="btn btn-info me-2">
                <i class="bx bx-receipt me-2"></i>Print Receipt
              </button>
            </div>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "BusinessDetailsModal",
  props: {
    businessDetails: {
      type: Object,
      default: () => ({})
    },
    billDetails: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    numberFormat(value) {
      if (!value) return '0';
      return new Intl.NumberFormat('en-US').format(value);
    },
    formatDate(date) {
      if (!date) return 'N/A';
      return moment(date).format('DD MMM YYYY');
    },
    copyToClipboard(text) {
      if (!text) return;
      navigator.clipboard.writeText(text).then(() => {
        // You can add a toast notification here
        alert('Copied to clipboard!');
      });
    }
  }
}
</script>

<style scoped>
.step-indicator {
  position: relative;
}

.step-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  font-size: 24px;
}

.step-indicator.completed::after {
  content: '';
  position: absolute;
  top: 30px;
  left: 60%;
  width: 100%;
  height: 2px;
  background-color: #28a745;
}

.step-indicator:last-child::after {
  display: none;
}

.modal-body {
  max-height: 80vh;
  overflow-y: auto;
}

.card {
  transition: all 0.3s ease;
}

.card:hover {
  transform: translateY(-2px);
}

label {
  font-weight: 500;
  margin-bottom: 4px;
}

.form-control[readonly], textarea[readonly] {
  background-color: #f8f9fa;
  cursor: default;
}

.bg-light {
  background-color: #f8f9fa !important;
}

.float-end {
  float: right;
}

.text-wrap {
  white-space: normal !important;
  word-wrap: break-word;
}
</style>